/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { autobind } from 'packages/core/lib';
import { loginCMByEmail, loginCMByPhone } from '../../requests/loader';

import {
  Grid,
  Row,
  Column,
  Keyboard,
  Button,
  Heading,
  Form,
  FormInput,
  cls,
  ColoredButton, TranslationID
} from 'packages/components';
import './_styles.scss';
import Assets from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';
import { LOGIN_CM } from '../utils/constants';
import Device from '../../devices/device';
import LoginCMLogic from './LoginCMLogic';
import { MODAL_REGISTER_NET, showModal } from '../../actions/modal';
import { regExp } from 'packages/components/lib/Input/utils';
import Spinner from './../../components/Spinner';
import HistoryRegion from '../../utils/HistoryRegion';
import { HeaderLoginLabels } from './HeaderBrasil';
import DeviceStorage  from '../../components/DeviceStorage/DeviceStorage';
import Utils from "../../utils/Utils";
import logger from 'src/utils/logger/logger';


enum Steps {
    STEP_MAIL = 'INSERT_MAIL',
    STEP_CODE = 'INSERT_CODE',
    STEP_PASSWORD = 'INSERT_PASSWORD'
}

interface IProps {
    errorMsg: string;
}

interface IPhoneConfiguration {
    minlength: string;
    maxlength: string;
    code: string;
}

interface IStepsValue {
    [key: string]: string | undefined;
    title: string;
    subtitle: string;
    placeholder: string;
    next?: string;
    cancel?: string;
    register?: string;
    buttonResend?: string;
}
interface ILoginState {
    step: string;
    email: string;
    password: string;
    code: string;
    showPassword: boolean;
    errorFromBackend: string;
    valid: boolean;
    isLoading: boolean;
    typeRegisterNet: string;
    device: string;
    focusWhenMount: boolean;
}

class Login extends Component<RouteComponentProps & IProps, ILoginState> {
    private translations: Record<TranslationID, string> = {
      'form_music_tooltip_empty_label_validation': Translator.get('form_music_tooltip_empty_label_validation','No olvides completar todos los campos. Verifica tu información para continuar.'),
      'emailPhone_music_tooltip_valid_label_validation': Translator.get('emailPhone_music_tooltip_valid_label_validation','Ingresa un número o correo electrónico válido.'),
      'phone_music_tooltip_length_label_validation': Translator.get('phone_music_tooltip_length_label_validation', 'El número no cumple con la longitud adecuada.')
    };
    public textBack: string = Translator.get('top_head_option_button_back', 'Regresar');
    public headerLogo: string = Assets.get('top_music_head_logoClaroMusica') || '';
    private loginLogic: LoginCMLogic;
    private isValidForm: boolean;
    private region: string;
    private defaultPhoneConfiguration: string = '{"minlength":10, "maxlength":10, "code": ""}'
    private regionPhoneConfiguration: IPhoneConfiguration = Utils.getApaMetadataKey("mobile_phone_music_configuration", this.defaultPhoneConfiguration);
    public keys = Device.getDevice() && Device.getDevice().getKeys() || null;
    public passwordShowButtonOff: string = Assets.get('password_access_show_button_off') || '';
    public passwordShowButtonOn: string = Assets.get('password_access_show_button_on') || '';
    private typeRegisterNetUpdate: string;

    constructor(props: RouteComponentProps & IProps) {
        super(props);
        this.state = {
            step: Steps.STEP_MAIL,
            email: '',
            password: '',
            code: '',
            showPassword: false,
            errorFromBackend: '',
            valid: true,
            isLoading: false,
            typeRegisterNet: this.props.location.typeRegisterNet,
            device: Device.getDevice().getPlatform(),
            focusWhenMount: true
        };

        this.loginLogic = new LoginCMLogic(props);
        this.isValidForm = false;
        this.region = DeviceStorage.getItem('region');
    }

    public componentDidUpdate(): void {
        const { step, code, password} = this.state;
        if (step === Steps.STEP_PASSWORD && password.length !== 0 && !this.isValidForm){
            this.handlePasswordChange(password);
        }
        if (step === Steps.STEP_CODE && code.length !== 0 && !this.isValidForm) {
            this.handleCodeChange(code);
        }
    }

    public componentDidMount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.handleKeyPress, true);
        document && document.addEventListener('keydown', this.onFocus, true);
        Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.removeEventListener('keydown', this.handleKeyPress, true);
        document && document.removeEventListener('keydown', this.onFocus, true);
    }

    private getTextBySteps = (attribute: string): string => {
        const { step } = this.state;
        let result: IStepsValue = {
            title: Translator.get('login_music_access_title_label','Inicia sesión'),
            subtitle: Translator.get('login_music_access_description_label','¿Cuál es tu número Telcel o tu correo electrónico?'),
            placeholder: Translator.get('login_music_access_placeHolder_textfield', 'Número a 10 dígitos o correo'),
            next: Translator.get('login_music_access_option_button_next','SIGUIENTE'),
            cancel: Translator.get('login_music_access_option_button_cancel','CANCELAR'),
            register: Translator.get('login_music_access_option_button_register','¿Nuevo en Claro música? Regístrate')
        };

        switch (step) {
            case Steps.STEP_MAIL:
                break;
            case Steps.STEP_CODE:
                result = {
                    title: Translator.get('login_music_validationCode_title_label','Inicia sesión'),
                    subtitle: Translator.get('login_music_validationCode_description_label','Código de validación'),
                    placeholder: '',
                    forgetPasswordBtn: Translator.get('login_music_validationCode_sendPIN_button_sendPin','REENVIAR CÓDIGO'),
                    next: Translator.get('login_music_validationCode_option_button_next','SIGUIENTE'),
                    cancel: Translator.get('login_music_validationCode_option_button_cancel','CANCELAR'),
                    buttonResend: Translator.get('login_music_validationCode_sendPIN_button_sendPIN', 'REENVIAR CÓDIGO')
                }
                break;
            case Steps.STEP_PASSWORD:
                result = {
                    title: Translator.get('login_music_password_title_label','Inicia sesión'),
                    subtitle: Translator.get('login_music_password_description_label','Contraseña'),
                    placeholder: Translator.get('login_music_password_placeHolder_textfield','Ingresa tu contraseña'),
                    forgetPasswordBtn: Translator.get('login_music_password_option_button_passwordRecovery','¿Olvidaste tu contraseña? Recupérala aquí'),
                    next: Translator.get('login_music_password_option_button_next','SIGUIENTE'),
                    cancel: Translator.get('login_music_password_option_button_cancel','CANCELAR'),
                };
                break;
            default:
                break;
        }

        return result[attribute] ?? '';
    };

     componentWillUpdate(NewProps: any){
        this.typeRegisterNetUpdate = NewProps.location.typeRegisterNet;
     }

    private handleStepPassword = (): void => {
        this.setState({ step: Steps.STEP_PASSWORD, valid: true, errorFromBackend: '' });
    };

    private handleStepCode = async (): Promise<void> => {
        const { email } = this.state;
        try {
            let response = await loginCMByPhone({phoneNumber: this.regionPhoneConfiguration.code + email, code: ''});
            if ( response.response === "SMS_SENT") {
                this.setState({ step: Steps.STEP_CODE, valid: true, errorFromBackend: '' });
            }
        } catch (error: any) {
            let message;
            if(error.code === "CMS_050") {
                message = Translator.get('CMS_050', 'Número no registrado en operadora Telcel.');
            }
            else if (error.code === "CMS_052") {
                message = Translator.get('CMS_052', 'Has excedido el número de intentos para ingresar a la aplicación. Por favor intenta nuevamente más tarde.');
            }
            else {
                if(error.code) {
                    message = Translator.get(error.code);
                }
                if(!message) {
                    message = error.message || "Ha ocurrido un error desconocido";
                }
            }
            this.setState({ valid: false, errorFromBackend: message })
        }
    }

    private resendCode = async ():Promise<void> => {
        const { email } = this.state;
        try {
            const response = await loginCMByPhone({phoneNumber: this.regionPhoneConfiguration.code + email});
            logger.debug('Se ha reenviado el código');
        } catch (error: any) {
            logger.error("Error al enviar código: ", error);
        }
    }

    async handleSubmit() {
        const  { email, password, code } = this.state;
        const loginParams = { email, password, phoneNumber: this.regionPhoneConfiguration.code + email, code, /* username: email,  includpaywayprofile: true */ };
        const { step, typeRegisterNet } = this.state;

        let loginFunction;
        if(this.state.step === Steps.STEP_CODE ) {
            loginFunction = loginCMByPhone;
        } else {
            loginFunction = loginCMByEmail;
        }

        await this.setState({isLoading: true});
        this.loginLogic.loginFLow(loginParams, loginFunction).then(error => {
            logger.debug("ERROR: ", error);
          if(error && (error.message || error.code)) {
            const errorMessage = error.code ? Translator.get(error.code, error.message) : error.message;
            this.isValidForm = false;
            this.setState({ valid: false, errorFromBackend: errorMessage, isLoading: false, password: '', code: '' });
          } else {
            this.props.history.replace("node/claromusica");
          }
        });
    }

    private handleCancel = (): void => {
        const { step } = this.state;
        switch (step) {
            case Steps.STEP_MAIL:
                this.handleHomeUser();
                break;
            case Steps.STEP_CODE:
                this.handleHomeUser();
                break;
            case Steps.STEP_PASSWORD:
                this.handleHomeUser();
                break;
            default:
                break;
        }
    };

    private handleHomeUser = (): void => {
        const { history } = this.props;
        history.push('/node/homeuser');
    };

    private changePasswordToShow = (): void => {
        const { showPassword } = this.state;
        this.setState({ showPassword: !showPassword });
    };

    private handleNextStep = (): void => {
        const { step, email, password, code } = this.state;
        let inputToValue: string;

        if(step === Steps.STEP_PASSWORD){
            inputToValue = password;
        } else if(step === Steps.STEP_CODE) {
            inputToValue = code;
        } else {
            inputToValue = email;
        }
        if (inputToValue === undefined || inputToValue === '') {
            this.setState({ valid: false, errorFromBackend: this.translations['form_music_tooltip_empty_label_validation']});
            return;
        }
        switch (step) {
            case Steps.STEP_MAIL:
                if(regExp.validEmail.test(inputToValue)) {
                    this.handleStepPassword();
                } else if(this.isValidPhoneNumber(inputToValue)) {
                    this.handleStepCode();
                } else {
                    if(/^\d{1,}$/.test(inputToValue)) {
                        this.setState({ valid: false, errorFromBackend: this.translations['phone_music_tooltip_length_label_validation']});
                    } else {
                        this.setState({ valid: false, errorFromBackend: this.translations['emailPhone_music_tooltip_valid_label_validation']});
                    }
                }
                break;
            case Steps.STEP_PASSWORD:
                this.handleSubmit();
                break;
            case Steps.STEP_CODE:
                this.handleSubmit();
                break;
            default:
                break;
        }
    };

    @autobind
    private handleBack():void {
        const { step, email } = this.state;
        const back = false;
        const islogin = true;

        if(step === Steps.STEP_PASSWORD || step === Steps.STEP_CODE){
            this.isValidForm = true;
            Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
            this.setState({ email, step: Steps.STEP_MAIL, errorFromBackend: '' });
        } else {
            const { history } = this.props;
            history.push('/node/homeuser');
        }
    }

    @autobind
    private handleEmailChange(value: string): void {
        let { valid } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || regExp.validEmail.test(value) || this.isValidPhoneNumber(value)) {
            valid = true;
        } else {
          valid = false;
        }
        this.setState({ email: value, valid, errorFromBackend: '' });
    }

    @autobind
    private handlePasswordChange(value: string): void {
        let { valid } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || regExp.validEmail.test(value) || regExp.hasNumberMobile.test(value)) {
            valid = true;
        }
        this.setState({ password: value, valid, errorFromBackend: '' });
    }

    @autobind
    private handleCodeChange(value: string): void {
        let { valid } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || regExp.hasNumberCode.test(value)) {
            valid = true;
        }
        this.setState({ code: value, valid, errorFromBackend: '' });
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "YELLOW":
                e.preventDefault();
                e.stopPropagation();
                if(Utils.isModalHide()) {
                  this.handleBack();
                }
            break;
        }
    }

    @autobind
    private handleKeyPress(e: any): void {
        const { step } = this.state;
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

        if (currentKey === 'BACK') {
            if(step == Steps.STEP_MAIL) {
                e.preventDefault();
                e.stopPropagation();
                this.handleBack();
            } else {
                this.isValidForm = true;
                this.setState({step: Steps.STEP_MAIL, valid:false, errorFromBackend: ''});
            }
        }
    }

    @autobind
    private onFocus (): void  {
        Utils.onFocusElement([{ id: 'emailInput'}, { id: 'password'}, {id: 'code'}]);
    }

    @autobind
    private isValidPhoneNumber(phoneNumber: string): boolean {
        let maxLength = this.regionPhoneConfiguration.maxlength;
        let minLength = this.regionPhoneConfiguration.minlength;
        let phoneValidationRegExp = new RegExp(`^[0-9]{${minLength},${maxLength}}$`);

        return phoneValidationRegExp.test(phoneNumber);

    }

    public render(): JSX.Element {
        if (this.state.isLoading) return <Spinner className ={cls(`${LOGIN_CM}-spinner`)} visible={true} />;
        const { step, showPassword, valid, errorFromBackend, focusWhenMount, email } = this.state;
        return (
            <Grid>
                <Row className={cls(`${LOGIN_CM}-row`)}>
                    <Column lg={3} className={cls(`${LOGIN_CM}-header-logo`)}>
                        <img src={this.headerLogo} alt="claroMusica logo" />
                    </Column>
                    <Column offset={7} lg={2} className={cls(`${LOGIN_CM}-header-buttons`)}>
                    <ColoredButton
                      onClick={this.handleBack}
                      children = {Translator.get('top_head_option_button_back','REGRESAR')}
                      color="yellow"
                      imgSrc = {Assets.get('top_head_option_back', '')}
                      onFocus = {this.onFocus}
                    />
                    </Column>
                </Row>
                <Row>
                    <Form id="user-registration-form">
                        <Column lg={6} className={cls(`${LOGIN_CM}-column-keyboard`)}>
                            <Keyboard  onFocus = {this.onFocus}/>
                        </Column>
                        <Column lg={6} className={cls(`${LOGIN_CM}-column-inputs`)}>
                            <Row className={cls(`${LOGIN_CM}-row-inputs`)}>
                                {/* ************** TITLE ****************** */}
                                {this.region.toLocaleLowerCase() === 'brasil'  && ( <Column lg={12} className={cls(`${LOGIN_CM}-column-Brasil`)}>
                                    <HeaderLoginLabels typeLogin = {this.typeRegisterNetUpdate} step = {step}></HeaderLoginLabels>
                                </Column>
                                )}

                                {this.region.toLocaleLowerCase() !== 'brasil' &&( <Column lg={12}>
                                    <Heading size={1} className={cls(`${LOGIN_CM}-title`)}>
                                        {this.getTextBySteps('title')}
                                    </Heading>
                                </Column>
                                )}

                                {/* ************** SUBTITLE ****************** */}
                                {this.region.toLocaleLowerCase() !== 'brasil' &&( <Column lg={12}>
                                    <Heading size={2} className={cls(`${LOGIN_CM}-subtitle`)}>
                                        {this.getTextBySteps('subtitle')}
                                    </Heading>
                                </Column>
                                )}

                                {/* ************** INPUT AND  BUTON PASSWORD, EMAIL ****************** */}
                                <Column lg={12} className={cls(`${LOGIN_CM}-column-input`)}>
                                    {step === Steps.STEP_MAIL && (
                                        <FormInput
                                            id = "emailInput"
                                            focusWhenMount = {focusWhenMount}
                                            name="email"
                                            type="alphanumeric"
                                            onChange={this.handleEmailChange}
                                            placeholder={this.getTextBySteps('placeholder')}
                                            errorFromBackend={errorFromBackend}
                                            validInput={valid}
                                            showTooltipSuccess={false}
                                            value={email}
                                        />
                                    )}
                                    {step === Steps.STEP_PASSWORD && (
                                        <Row>
                                            <Column lg={8}>
                                                <FormInput
                                                    id="password"
                                                    focusWhenMount = {focusWhenMount}
                                                    type={
                                                        !showPassword
                                                            ? 'password'
                                                            : 'password_shown'
                                                    }
                                                    onChange={this.handlePasswordChange}
                                                    name="password"
                                                    placeholder={this.getTextBySteps('placeholder')}
                                                    errorFromBackend={errorFromBackend}
                                                    validInput={valid}
                                                />
                                            </Column>
                                            <Column
                                                lg={4}
                                                className={cls(`${LOGIN_CM}-column-show-password`)}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="default"
                                                    className={cls(
                                                        `focusable`,
                                                        `${LOGIN_CM}-button-show-password`
                                                    )}
                                                    onClick={this.changePasswordToShow}
                                                    block
                                                    img = {!showPassword ? this.passwordShowButtonOff : this.passwordShowButtonOn }
                                                >
                                                </Button>
                                            </Column>
                                        </Row>
                                    )}
                                    {step === Steps.STEP_CODE && (
                                        <Row>
                                            <Column lg={8}>
                                                <FormInput
                                                    id="code"
                                                    focusWhenMount = {focusWhenMount}
                                                    type='password_shown'
                                                    onChange={this.handleCodeChange}
                                                    name="code"
                                                    errorFromBackend={errorFromBackend}
                                                    validInput={valid}
                                                />
                                            </Column>
                                            <Column
                                                lg={4}
                                                className={cls(`${LOGIN_CM}-column-show-password`)}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="default"
                                                    className={cls(
                                                        `focusable`,
                                                        `${LOGIN_CM}-button-show-password`
                                                    )}
                                                    // HAY QUE IMPLEMENTAR EL MÉTODO RESENDCODE
                                                    onClick={this.resendCode}
                                                    block
                                                >
                                                    {this.getTextBySteps('buttonResend')}
                                                </Button>
                                            </Column>
                                        </Row>
                                    )}
                                </Column>

                                {/* ************** CANCEL BUTTON AND CONFIRM BUTTON ****************** */}
                                <Column lg={11}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        className={cls(`focusable`, `${LOGIN_CM}-button-next`, this.isValidForm ? '' : 'disabled')}
                                        onClick={this.handleNextStep}
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('next')}
                                    </Button>
                                </Column>
                                <Column lg={11} className={cls(`${LOGIN_CM}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(`focusable`, `${LOGIN_CM}-button-cancel`)}
                                        onClick={this.handleCancel}
                                        block
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('cancel')}
                                    </Button>
                                </Column>
                             {/* ************** REGISTER BUTTON ************** */}
                             {/* {step === Steps.STEP_MAIL && (
                                    <Column lg={12}>
                                        <Row className={cls(`${LOGIN_CM}-row-register`)}>
                                            <Column
                                                lg={6}
                                                className={cls(`${LOGIN_CM}-column-button-register`)}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="dark"
                                                    className={cls(
                                                        `focusable`,
                                                        `${LOGIN_CM}-column-button-register`
                                                    )}
                                                    onClick={this.gotoRegister}
                                                    onFocus = {this.onFocus}
                                                >
                                                    {this.getTextBySteps('register')}
                                                </Button>
                                            </Column>
                                        </Row>
                                    </Column>
                                )} */}
                                {/* ************** FORGOT PASSWORD ****************** */}
                                {/* {step === Steps.STEP_PASSWORD && (
                                    <Column lg={12}>
                                        <Row className={cls(`${LOGIN_CM}-row-forgotten-password`)}>
                                            <Column
                                                lg={6}
                                                className={cls(
                                                    `${LOGIN_CM}-column-button-forgotten-password`
                                                )}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="dark"
                                                    className={cls(
                                                        `focusable`,
                                                        `${LOGIN_CM}-column-button-forgotten-password`
                                                    )}
                                                    onClick={this.handleForgetPassword}
                                                    onFocus = {this.onFocus}
                                                >
                                                    {this.getTextBySteps('forgetPasswordBtn')}
                                                </Button>
                                            </Column>
                                        </Row>
                                    </Column>
                                )} */}
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
};

// eslint-disable-next-line no-unused-expressions
// eslint-disable-next-line @typescript-eslint/no-explicit-any

function mapStateToProps(state: any) {
    return { }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/authentication/LoginCM/index.tsx